// EmployeeCompanyConfiguration.js

import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

function DepartmentConfiguration() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [department, setDepartment] = useState({
    name: '',
    company:'',
    contact_info: ''
  });
  const [error, setError] = useState(null); // Error state
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
 
  const { id } = useParams();  // Get company ID from the URL for editing
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (id) {

      console.log('department id:', id);

      // If the ID exists, fetch the company details for editing
      setIsEditing(true);
      fetch(`${API_BASE_URL}/departments/get_departments.php?id=${id}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Handle empty or invalid JSON responses gracefully
        return response.text().then(text => {
          try {
            return JSON.parse(text);
          } catch (error) {
            console.log('text:', text);
            throw new Error('Invalid JSON response');
          }
        });
      })
        .then(data => {
          console.log('data:', data);
          setDepartment({
            name: data.name,
            company: data.company,  // Assuming company_id from API response
            contact_info: data.contact_info
          });
          console.log('department:', department);
        })
        .catch(error => console.error('Error fetching company:', error));
    }
  }, [id]);

    // Fetch companies on component mount
    useEffect(() => {
      const fetchCompanies = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/companies/get_companies.php`);
          const data = await response.json();
          if (Array.isArray(data)) {
            setCompanies(data);
          } else {
            throw new Error("Invalid companies data format");
          }
        } catch (error) {
          setError(error.message);
         }
      };
      fetchCompanies();
    }, []);

  //const [company, setCompany] = useState([]);

  const handleChange = e => {
    const { name, value } = e.target;
    setDepartment(prevDepartment => ({
      ...prevDepartment,
      [name]: value
    }));
  };

  const handleSave = () => {

    const form = document.querySelector('form');  // Select the form element
    if (!form.checkValidity()) {
      Swal.fire({ icon: 'warning', text: 'Please fill in all required fields.' });
      return;
    }

    const formData = new FormData();
    formData.append('companyId', department.company);
    formData.append('name', department.name);
    formData.append('contact_info', department.contact_info);
    if (isEditing) {
      formData.append('id', id);
      formData.append('isUpdate', 1);
    }
    console.log('Department data:', department);
    console.log('FormData content:', [...formData.entries()]);

    fetch(`${API_BASE_URL}/departments/save_department.php`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      // Handle empty or invalid JSON responses gracefully
      return response.text().then(text => {
        try {
          return JSON.parse(text);
        } catch (error) {
          console.log('text:', text);
          throw new Error('Invalid JSON response');
        }
      });
    })
    .then(data => {
      console.log('Data:', data);
      if (data.success) {
        navigate('/config/department-list');
      } else {
        Swal.fire({ icon: 'error', text: 'Failed to save department: ' + data.message });
      }
    })
    .catch(error => {
      console.error('Error:', error);
      Swal.fire({ icon: 'error', text: 'An error occurred: ' + error.message });
    });

   
  };

  const handleCancel = () => {
    // Redirect back to the admin dashboard without saving
    navigate('/config/department-list');
  };

  return (
    <div className='p-2'>
      <h2>Department Configuration</h2>
      <Form>
        <Form.Group controlId="companyId">
          <Form.Label>Company Name</Form.Label>
          <Form.Control as="select" name="company" value={department.company} onChange={handleChange} required>
                <option value="">Select Company</option>
                {companies.map(company => (
                  <option key={company.id} value={company.id}>
                    {company.name}
                  </option>
                ))}
              </Form.Control>
        </Form.Group>
        <Form.Group controlId="departmentName">
          <Form.Label>Department Name</Form.Label>
          <Form.Control type="text" name="name" value={department.name} onChange={handleChange} required/>
        </Form.Group>
        <Form.Group controlId="contactInformation">
          <Form.Label>Contact Information</Form.Label>
          <Form.Control as="textarea" name="contact_info" value={department.contact_info} onChange={handleChange} />
        </Form.Group>
      </Form>
      <div className='mt-2'>
      <Button variant="primary" className="mr-2" onClick={handleSave}>Save</Button>
      <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
      </div>
    </div>
  );
}

export default DepartmentConfiguration;
